var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outline":"","height":"40px"},on:{"click":function($event){return _vm.SignIn()}}},[_c('v-icon',{staticStyle:{"font-size":"30px"},attrs:{"color":"primary"}},[_vm._v("mdi-microsoft-azure")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }